import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProviderGroupState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ProviderGroupState = {
  data: [],
  isLoading: false,
  error: null,
};

const companyGroupSlice = createSlice({
  name: 'companyGroups',
  initialState,
  reducers: {
    setCompanyGroups: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setCompanyGroupLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setCompanyGroupError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setCompanyGroups, setCompanyGroupLoading, setCompanyGroupError } = companyGroupSlice.actions;

export default companyGroupSlice.reducer;
